import baseballChallengeSvg from "@/assets/baseball_challenge.svg";

import { ChallengeButton } from "./components/ChallengeButton";

interface Props {
  secondsLeft: number;
  size?: "small" | "large";
}

export const CountdownUI = ({ secondsLeft, size = "small" }: Props) => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 px-3">
      <div className="flex flex-col items-center justify-center gap-2">
        <img
          src={baseballChallengeSvg}
          alt="Challenge"
          className="h-8 w-auto"
        />

        <div className="flex flex-col items-center justify-center gap-1">
          <h2
            className={`text-center font-bold text-text-light ${
              size === "large" ? "text-xl" : "text-base"
            }`}
          >
            Challenge the pitch?
          </h2>

          <p
            className={`text-center text-gray-600 ${
              size === "large" ? "text-base" : "text-sm"
            }`}
          >
            {secondsLeft} second{secondsLeft !== 1 ? "s" : ""} left
          </p>
        </div>
      </div>

      <ChallengeButton size="lg" />
    </div>
  );
};
